import {buildCustomFieldsPayloadForCreate} from 'src/marketConnect/helpers/crud-helper/helpers'

export const buildOrderCustomFieldsPayload = (
  customFieldsValues: Record<number, any>,
  fieldsMeta: any[]
) => {
  const built = buildCustomFieldsPayloadForCreate(customFieldsValues, fieldsMeta)

  return (built || []).map((row: any) => {
    if ('platform_field_data_id' in row) return row
    const {platform_field_data, ...rest} = row
    return {...rest, platform_field_data_id: platform_field_data ?? null}
  })
}
